import { useMemo } from 'react';
function useMultipleMemoClasses(classesArrayGroups, deps) {
    var resultingArray = useMemo(function () { return classesArrayGroups.map(function (classesArray) { return classesArray.filter(function (_) { return _; }).join(' '); }); }, deps);
    return resultingArray;
}
export default useMultipleMemoClasses;
